import { CustomValidators } from './../shared/validators/custom-validators';
import { SaveStageModel } from './stage-save.model';
import { SelectListItemModel } from './../shared/models/select-list-item.model';
import { MapperHelper } from './../shared/mapper-helper';
import { JsonParserHelper } from './../shared/json-parser-helper';
import { Response, RequestOptions } from '@angular/http';
import { QuestionBaseModel } from './../shared/models/question-base.model';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators, ValidatorFn } from '@angular/forms';
import { SchoolsModel } from '../shared/models/schools.model';
import { SummerAppFieldsValidators } from 'app/shared/enums/fields-validators.enum';
import 'rxjs/add/observable/concat';
import { AppSettings } from 'app/shared/app-settings';
import { SummerAppFieldTypesEnum } from '../shared/enums/field-types.enum';

@Injectable()
export class StageQuestionsService {

    constructor(private http: HttpClient) {

    }

    getStagesQuestions(): Observable<QuestionBaseModel<any>[]> {
        return this.http.post<any[]>(AppSettings.endpoints.enrollees.configuration, {}).map((res) => {
            return MapperHelper.mapQuestionsFields(res);
        });
    }


    toFormGroup(questions: QuestionBaseModel<any>[]) {
        let group: any = {};
        questions.forEach(question => {
            group[question.fieldName] = new FormControl(question.value || '');
            let validators = this.getQuestionValidators(question);
            if (validators)
                (<FormControl>group[question.fieldName]).setValidators(validators);
        });
        return new FormGroup(group);
    }

    private getQuestionValidators(question: QuestionBaseModel<any>): ValidatorFn[] {
        let validators: ValidatorFn[] = [];
        if (question.maxLength)
            validators.push(Validators.maxLength(question.maxLength));

        if (question.isRequired)
            validators.push(Validators.required);

        if(question.fieldTypeName == SummerAppFieldTypesEnum.Input &&
            (question.validatorName == SummerAppFieldsValidators.Name))
            validators.push(CustomValidators.isName());

        if (question.validatorName == SummerAppFieldsValidators.SSN)
            validators.push(CustomValidators.MaskedMinLength(11));

        if (question.validatorName == SummerAppFieldsValidators.Zip)
            validators.push(CustomValidators.MaskedMinLength(5));

        if (question.validatorName == SummerAppFieldsValidators.PhoneNumber)
            validators.push(CustomValidators.MaskedMinLength(13));

        if (question.fieldTypeName == SummerAppFieldTypesEnum.Numeric)
            validators.push(CustomValidators.isNumeric());

        // if (question.fieldTypeName == SummerAppFieldTypesEnum.Date)
        //     validators.push(CustomValidators.isDate());

        if (question.label == 'SNAP Amount') {
            validators.pop();
            validators.push(CustomValidators.isIntegerSNAP());
        }

        return validators;
    }

    private _stages: any;
    getStagesLookup(): Observable<SelectListItemModel[]> {
        if (!this._stages)
            this._stages = this.http.get<SelectListItemModel[]>(AppSettings.endpoints.enrollees.stagesLookup).shareReplay(1);
        return this._stages;
    }

    saveStage(model: SaveStageModel, doc: File): Observable<any> {
        if (doc)
            return Observable.concat(this._uploadFile(doc), this._saveStage(model));
        else
            return this._saveStage(model);
    }

    private _saveStage(model: SaveStageModel): Observable<any> {
        return this.http.post(AppSettings.endpoints.enrollees.saveStage, model, AppSettings.EMPTY_REQUEST_OPTIONS).map(res => { return true });
    }


    private _uploadFile(doc: File): Observable<any> {
        let formData = new FormData();
        formData.append('document', doc);
        return this.http.post(AppSettings.endpoints.enrollees.uploadDocument, formData, AppSettings.EMPTY_REQUEST_OPTIONS);
    }

    private schoolsObserver: any;
    loadSchoolOptions(): Observable<SchoolsModel[]> {
        if (!this.schoolsObserver) {
            let url = AppSettings.formatUrl(AppSettings.endpoints.enrollees.schools, '');
            return this.schoolsObserver = this.http.get<SchoolsModel[]>(url, {}).shareReplay(1);
        }
        return this.schoolsObserver;
    }

    // regenDocuments(applicantId: number): Observable<any>{
    //     let url = AppSettings.formatUrl(AppSettings.endpoints.enrollees.enrollmentUpdateDocReq, applicantId)
    //     return this.http.post(url, {});
    // }

    checkReferralCode(code): Observable<boolean> {
        if (!code)
            return Observable.of(true);
        let url = AppSettings.formatUrl(AppSettings.endpoints.enrollees.checkReferral, code);
        return this.http.post<boolean>(url, {});
    }

    submitApplication(): Observable<any> {
        return this.http.post(AppSettings.endpoints.enrollees.submitApplication, {}, AppSettings.EMPTY_REQUEST_OPTIONS);
    }

}



// WEBPACK FOOTER //
// ./src/app/stages/stage-questions.service.ts